import React, { useState } from 'react';

import { useDispatch } from 'react-redux';

import { useFeatures } from '@atc/features';

import { Button, Image, OverlayTrigger, Popover } from 'reaxl';

import scrollToElement from '@/utilities/scrollToElement';

import vdpActiveInteractionDuck from '@/ducks/vdp/vdpActiveInteractionDuck.js';

function PsxVerificationContainer() {
    const {
        psx_logo: [, {
            icon: psxIcon,
            width: psxWidth,
        }],
    } = useFeatures([
        'psx_logo',
    ]);

    const dispatch = useDispatch();

    const [isFirstClick, setIsFirstClick] = useState(true);

    const handleVerifiedClick = () => {
        scrollToElement('psx-faq', undefined, isFirstClick ? {
            smoothScrollOptions: {
                duration: 750,
                ease: (n) => n,
            },
            afterScrollSmoothScrollOptions: {
                duration: 250,
            },
        } : {});
        dispatch(vdpActiveInteractionDuck.creators.setKeys({ showPsxExplainerContent: 'verification' }));
        setIsFirstClick(false);
    };

    return (
        <div style={{ minHeight: '45px' }}>
            <Image
                src={psxIcon}
                alt="Private Seller Exchange"
                height={27}
                width={psxWidth}
                lazyload={false}
                loading="eager"
                className="margin-top-1 margin-bottom-3 margin-right-2"
            />

            <OverlayTrigger
                trigger="click"
                rootClose
                placement="top"
                overlay={(
                    <Popover
                        id="PSX-verified"
                    >
                        We&rsquo;ve performed a multi-check assessment to verify the car&rsquo;s registered owner, vehicle history reports, and safety assessments.
                        {' '}
                        <Button
                            bsStyle="text-decorated"
                            onClick={handleVerifiedClick}
                        >
                            Learn More
                        </Button>
                    </Popover>
                )}
            >
                <Button
                    bsStyle="text"
                >
                    <Image
                        src="/cm-api/content/static/img/psx/verified-vehicle-badge.svg"
                        alt="Verified Vehicle"
                        height={27}
                        width={144}
                        lazyload={false}
                        loading="eager"
                        className="margin-top-1 margin-bottom-3"
                    />
                </Button>
            </OverlayTrigger>

        </div>
    );
}

export default React.memo(PsxVerificationContainer);
